import React from 'react';

export function NexusPageHeader({ title, subtitle, actions }) {
  return (
    <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', gap: 16, alignItems: 'flex-start' }}>
      <div>
        <h1>{title}</h1>
        {subtitle ? <p>{subtitle}</p> : null}
      </div>
      {actions ? <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>{actions}</div> : null}
    </div>
  );
}

export function EmptyState({ icon, message }) {
  return (
    <div className="empty-state">
      {icon ? <div className="icon">{icon}</div> : null}
      <p>{message || 'No records found'}</p>
    </div>
  );
}

export function PaginationInfo({ count, label = 'records' }) {
  return (
    <div className="pagination">
      <span className="page-info">{Number(count || 0).toLocaleString()} {label}</span>
    </div>
  );
}
